import _regeneratorRuntime from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var NewRequestService = /*#__PURE__*/function () {
  function NewRequestService(token) {
    _classCallCheck(this, NewRequestService);

    this.token = token;
  }

  _createClass(NewRequestService, [{
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, data) {
        var _this = this;

        var BaseURL, Payload;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                Payload = data instanceof FormData ? data : JSON.stringify(data);
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'POST',
                    body: Payload,
                    headers: {
                      Accept: 'application/json'
                    }
                  };

                  if (!(data instanceof FormData)) {
                    payload.headers['Content-Type'] = 'application/json';
                  }

                  if (_this.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this.token);
                  }

                  fetch(BaseURL + type, payload).then( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
                      var error, json;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              error = response.status > 299 || response.status < 199;
                              _context.prev = 1;

                              if (!response.json) {
                                _context.next = 8;
                                break;
                              }

                              _context.next = 5;
                              return response.json();

                            case 5:
                              _context.t0 = _context.sent;
                              _context.next = 9;
                              break;

                            case 8:
                              _context.t0 = null;

                            case 9:
                              json = _context.t0;
                              _context.next = 15;
                              break;

                            case 12:
                              _context.prev = 12;
                              _context.t1 = _context["catch"](1);
                              console.warn('Unable to parse JSON from API response', _context.t1);

                            case 15:
                              if (!error) {
                                _context.next = 17;
                                break;
                              }

                              return _context.abrupt("return", reject({
                                error: 'Request error',
                                status: response.status,
                                statusText: response.statusText,
                                errorCode: json && json.errors ? json.errors : null
                              }));

                            case 17:
                              return _context.abrupt("return", resolve(json));

                            case 18:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[1, 12]]);
                    }));

                    return function (_x3) {
                      return _ref.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function post(_x, _x2) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "rawGet",
    value: function () {
      var _rawGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, settings) {
        var _this2 = this;

        var BaseURL;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/");
                settings = settings || {};
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'GET',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json'
                    }
                  };

                  if (settings.tokenify) {
                    if (_this2.token) {
                      payload.headers.Authorization = "Bearer ".concat(_this2.token);
                    }
                  }

                  fetch(BaseURL + url, payload).then(function (response) {
                    if (response.status > 299 || response.status < 199) {
                      return reject({
                        error: 'Request error',
                        status: response.status,
                        statusText: response.statusText
                      });
                    }

                    if (settings.text) {
                      response = response.text();
                    } else {
                      response = response.json();
                    }

                    return resolve(response);
                  }).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function rawGet(_x4, _x5) {
        return _rawGet.apply(this, arguments);
      }

      return rawGet;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(type) {
        var _this3 = this;

        var BaseURL;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'GET',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json'
                    }
                  };

                  if (_this3.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this3.token);
                  }

                  fetch(BaseURL + type, payload).then( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response) {
                      var error, json;
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              error = response.status > 299 || response.status < 199;
                              _context4.prev = 1;

                              if (!response.json) {
                                _context4.next = 8;
                                break;
                              }

                              _context4.next = 5;
                              return response.json();

                            case 5:
                              _context4.t0 = _context4.sent;
                              _context4.next = 9;
                              break;

                            case 8:
                              _context4.t0 = null;

                            case 9:
                              json = _context4.t0;
                              _context4.next = 15;
                              break;

                            case 12:
                              _context4.prev = 12;
                              _context4.t1 = _context4["catch"](1);
                              console.warn('Unable to parse JSON from API response', _context4.t1);

                            case 15:
                              if (!error) {
                                _context4.next = 17;
                                break;
                              }

                              return _context4.abrupt("return", reject({
                                error: 'Request error',
                                status: response.status,
                                statusText: response.statusText,
                                errorCode: json && json.errors ? json.errors : null
                              }));

                            case 17:
                              return _context4.abrupt("return", resolve(json));

                            case 18:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4, null, [[1, 12]]);
                    }));

                    return function (_x7) {
                      return _ref2.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function get(_x6) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(type, data) {
        var _this4 = this;

        var BaseURL, Payload;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                Payload = data instanceof FormData ? data : JSON.stringify(data);
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'DELETE',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: Payload
                  };

                  if (_this4.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this4.token);
                  }

                  fetch(BaseURL + type, payload).then( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(response) {
                      var error, json;
                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              error = response.status > 299 || response.status < 199;
                              _context6.prev = 1;

                              if (!response.json) {
                                _context6.next = 8;
                                break;
                              }

                              _context6.next = 5;
                              return response.json();

                            case 5:
                              _context6.t0 = _context6.sent;
                              _context6.next = 9;
                              break;

                            case 8:
                              _context6.t0 = null;

                            case 9:
                              json = _context6.t0;
                              _context6.next = 15;
                              break;

                            case 12:
                              _context6.prev = 12;
                              _context6.t1 = _context6["catch"](1);
                              console.warn('Unable to parse JSON from API response', _context6.t1);

                            case 15:
                              if (!error) {
                                _context6.next = 17;
                                break;
                              }

                              return _context6.abrupt("return", reject({
                                error: 'Request error',
                                status: response.status,
                                statusText: response.statusText,
                                errorCode: json && json.errors ? json.errors : null
                              }));

                            case 17:
                              return _context6.abrupt("return", resolve(json));

                            case 18:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6, null, [[1, 12]]);
                    }));

                    return function (_x10) {
                      return _ref3.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function _delete(_x8, _x9) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "updateFolder",
    value: function () {
      var _updateFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(urlEndPoint, folderId) {
        var _this5 = this;

        var projectId,
            BaseURL,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                projectId = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : null;
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                return _context9.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'PUT',
                    body: JSON.stringify({
                      folder_id: folderId,
                      project_id: projectId
                    }),
                    headers: {
                      Accept: 'application/json'
                    }
                  };
                  payload.headers['Content-Type'] = 'application/json';

                  if (_this5.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this5.token);
                  }

                  var fetchUrl = BaseURL + urlEndPoint;
                  fetch(fetchUrl, payload).then( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(response) {
                      var error, json;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              error = response.status > 299 || response.status < 199;
                              _context8.prev = 1;

                              if (!response.json) {
                                _context8.next = 8;
                                break;
                              }

                              _context8.next = 5;
                              return response.json();

                            case 5:
                              _context8.t0 = _context8.sent;
                              _context8.next = 9;
                              break;

                            case 8:
                              _context8.t0 = null;

                            case 9:
                              json = _context8.t0;
                              _context8.next = 15;
                              break;

                            case 12:
                              _context8.prev = 12;
                              _context8.t1 = _context8["catch"](1);
                              console.warn('Unable to parse JSON from API response', _context8.t1);

                            case 15:
                              if (!error) {
                                _context8.next = 17;
                                break;
                              }

                              return _context8.abrupt("return", reject({
                                error: 'Request error',
                                status: response.status,
                                statusText: response.statusText,
                                errorCode: json && json.errors ? json.errors : null
                              }));

                            case 17:
                              if (!(typeof response.length !== 'undefined')) {
                                _context8.next = 20;
                                break;
                              }

                              response = response.length > 0 ? response = json : response;
                              return _context8.abrupt("return", resolve(response));

                            case 20:
                              if (!json) {
                                _context8.next = 23;
                                break;
                              }

                              response = json;
                              return _context8.abrupt("return", resolve(response));

                            case 23:
                              console.log('Unexpected response state after POST!!');
                              return _context8.abrupt("return", resolve());

                            case 25:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8, null, [[1, 12]]);
                    }));

                    return function (_x13) {
                      return _ref4.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function updateFolder(_x11, _x12) {
        return _updateFolder.apply(this, arguments);
      }

      return updateFolder;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(type, data) {
        var _this6 = this;

        var useFormData,
            BaseURL,
            formData,
            key,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                useFormData = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : false;
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                formData = new FormData();

                if (useFormData) {
                  for (key in data) {
                    formData.append(key, data[key]);
                  }
                }

                return _context11.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: useFormData ? 'POST' : 'PUT',
                    body: useFormData ? formData : JSON.stringify(data),
                    headers: {
                      Accept: 'application/json'
                    }
                  };

                  if (!useFormData) {
                    payload.headers['Content-Type'] = 'application/json';
                  }

                  var token = data.token || _this6.token;

                  if (token) {
                    payload.headers.Authorization = "Bearer ".concat(token);
                  }

                  var fetchUrl = BaseURL + type;

                  if (useFormData) {
                    fetchUrl += '?_method=PUT';
                  }

                  fetch(fetchUrl, payload).then( /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(response) {
                      var error, json;
                      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              error = response.status > 299 || response.status < 199;
                              _context10.prev = 1;

                              if (!response.json) {
                                _context10.next = 8;
                                break;
                              }

                              _context10.next = 5;
                              return response.json();

                            case 5:
                              _context10.t0 = _context10.sent;
                              _context10.next = 9;
                              break;

                            case 8:
                              _context10.t0 = null;

                            case 9:
                              json = _context10.t0;
                              _context10.next = 15;
                              break;

                            case 12:
                              _context10.prev = 12;
                              _context10.t1 = _context10["catch"](1);
                              console.warn('Unable to parse JSON from API response', _context10.t1);

                            case 15:
                              if (!error) {
                                _context10.next = 17;
                                break;
                              }

                              return _context10.abrupt("return", reject({
                                error: 'Request error',
                                status: response.status,
                                statusText: response.statusText,
                                errorCode: json && json.errors ? json.errors : null
                              }));

                            case 17:
                              if (!(typeof response.length !== 'undefined')) {
                                _context10.next = 20;
                                break;
                              }

                              response = response.length > 0 ? response = json : response;
                              return _context10.abrupt("return", resolve(response));

                            case 20:
                              if (!json) {
                                _context10.next = 23;
                                break;
                              }

                              response = json;
                              return _context10.abrupt("return", resolve(response));

                            case 23:
                              console.log('Unexpected response state after POST!!');
                              return _context10.abrupt("return", resolve());

                            case 25:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10, null, [[1, 12]]);
                    }));

                    return function (_x16) {
                      return _ref5.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function put(_x14, _x15) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "getImage",
    value: function () {
      var _getImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(type) {
        var _this7 = this;

        var BaseURL;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                return _context12.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'GET',
                    headers: {
                      Accept: 'image/*',
                      'Content-Type': 'image/*'
                    }
                  };

                  if (_this7.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this7.token);
                  }

                  fetch(BaseURL + type, payload).then(function (response) {
                    if (response.status > 299 || response.status < 199) {
                      return reject({
                        error: 'Request error',
                        status: response.status,
                        statusText: response.statusText
                      });
                    }

                    return resolve(response.blob());
                  }).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function getImage(_x17) {
        return _getImage.apply(this, arguments);
      }

      return getImage;
    }()
  }, {
    key: "postUserPhoto",
    value: function () {
      var _postUserPhoto = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(type, photo) {
        var _this8 = this;

        var BaseURL, EndURL;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                EndURL = '?_method=PUT';
                return _context13.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'POST',
                    headers: {
                      accept: '*/*'
                    },
                    body: photo
                  };

                  if (_this8.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this8.token);
                  }

                  fetch(BaseURL + type + EndURL, payload).then(function (response) {
                    if (response.status > 299 || response.status < 199) {
                      return reject({
                        error: 'Request error',
                        status: response.status,
                        statusText: response.statusText
                      });
                    }

                    return resolve(response);
                  }).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function postUserPhoto(_x18, _x19) {
        return _postUserPhoto.apply(this, arguments);
      }

      return postUserPhoto;
    }()
  }, {
    key: "postPhoto",
    value: function () {
      var _postPhoto = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(type, photo) {
        var _this9 = this;

        var BaseURL, EndURL;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                EndURL = '?_method=PUT';
                return _context14.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'POST',
                    headers: {
                      accept: '*/*'
                    },
                    body: photo
                  };

                  if (_this9.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this9.token);
                  }

                  fetch(BaseURL + type + EndURL, payload).then(function (response) {
                    if (response.status > 299 || response.status < 199) {
                      return reject({
                        error: 'Request error',
                        status: response.status,
                        statusText: response.statusText
                      });
                    }

                    return resolve(response);
                  }).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function postPhoto(_x20, _x21) {
        return _postPhoto.apply(this, arguments);
      }

      return postPhoto;
    }()
  }, {
    key: "csvImport",
    value: function () {
      var _csvImport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(type, data) {
        var _this10 = this;

        var BaseURL, EndURL;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                EndURL = '?_method=PUT';
                return _context16.abrupt("return", new Promise(function (resolve, reject) {
                  var payload = {
                    method: 'POST',
                    headers: {
                      accept: '*/*'
                    },
                    body: data
                  };

                  if (_this10.token) {
                    payload.headers.Authorization = "Bearer ".concat(_this10.token);
                  }

                  fetch(BaseURL + "import/csv/" + type + EndURL, payload).then( /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(response) {
                      var json;
                      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                        while (1) {
                          switch (_context15.prev = _context15.next) {
                            case 0:
                              if (!(response.status > 299 || response.status < 199)) {
                                _context15.next = 2;
                                break;
                              }

                              return _context15.abrupt("return", reject({
                                error: 'Request error',
                                status: response.status,
                                statusText: response.statusText
                              }));

                            case 2:
                              _context15.prev = 2;

                              if (!response.json) {
                                _context15.next = 9;
                                break;
                              }

                              _context15.next = 6;
                              return response.json();

                            case 6:
                              _context15.t0 = _context15.sent;
                              _context15.next = 10;
                              break;

                            case 9:
                              _context15.t0 = null;

                            case 10:
                              json = _context15.t0;
                              _context15.next = 16;
                              break;

                            case 13:
                              _context15.prev = 13;
                              _context15.t1 = _context15["catch"](2);
                              console.warn('Unable to parse JSON from API response', _context15.t1);

                            case 16:
                              if (!json) {
                                _context15.next = 19;
                                break;
                              }

                              response = json;
                              return _context15.abrupt("return", resolve(response));

                            case 19:
                              return _context15.abrupt("return", resolve(response));

                            case 20:
                            case "end":
                              return _context15.stop();
                          }
                        }
                      }, _callee15, null, [[2, 13]]);
                    }));

                    return function (_x24) {
                      return _ref6.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    NewRequestService.rejectWrapper(error, reject);
                  });
                }));

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function csvImport(_x22, _x23) {
        return _csvImport.apply(this, arguments);
      }

      return csvImport;
    }()
  }], [{
    key: "rejectWrapper",
    value: function rejectWrapper(thing, reject) {
      console.log('RejectWrapper is firing for', thing);

      if (thing instanceof TypeError) {
        // Most likely the core is down or unreachable -- check locally by simply shutting down the core while using the app
        // Show an error to the user - this is completely outside of react, defined in index.html
        // TODO: const e = document.getElementById("connection-issue-modal");
        // TODO: e.classList.add("active");
        // TODO: Add loop to retry connection and show the user that this happens
        console.error('TypeError when contacting the core  - core unavailable?');
        reject(thing);
        return;
      }

      console.error('Unknown error when contacting core', thing);
      reject(thing);
    }
  }]);

  return NewRequestService;
}();

export { NewRequestService as default };